import { useEffect, useState } from "react";
import AnimatedTitle from "../../../components/AnimatedTitle";
import AnimatedBox from "../../../components/AnimatedBox";

const data = [
  {
    img: "/reduction.png",
    line1: "50%",
    line2: "Reduction in Cost",
    line3: "Cut your expenses with smart automation tools.",
  },
  {
    img: "/faster.png",
    line1: "70%",
    line2: "Faster Implementation",
    line3: "Deploy solutions in record-breaking time easily.",
  },
  {
    img: "/boost.png",
    line1: "200%",
    line2: "Boost in Productivity",
    line3: "Supercharge your team's output seamlessly.",
  },
];

function RevolutionSection() {
  const [isNotLg, setIsNotLg] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsNotLg(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.textContent = `
      .hover-container {
        position: relative;
      }
      .hover-container .transition-opacity:first-child {
        opacity: 1;
        z-index: 2;
        transition: opacity 700ms ease-in-out;
      }
      .hover-container .transition-opacity:last-child {
        opacity: 0;
        z-index: 1;
        transition: opacity 700ms ease-in-out;
      }
      .hover-container:hover .transition-opacity:first-child {
        opacity: 0;
        z-index: 1;
      }
      .hover-container:hover .transition-opacity:last-child {
        opacity: 1;
        z-index: 2;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <section className="w-full py-24">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
        <AnimatedTitle
          className="text-3xl font-semibold mb-10"
          style={{ color: "var(--color-primary)" }}
        >
          Revolution of Building Data platform
        </AnimatedTitle>

        <div className="flex flex-wrap justify-center gap-7">
          {isNotLg
            ? data.map((box, idx) => (
                <AnimatedBox
                  key={`front-${idx}`}
                  className="flex flex-col items-center pt-8 pb-10 px-4 rounded-3xl h-full w-full max-w-sm transition-opacity"
                  style={{
                    backgroundImage: "url('/box.png')",
                    backgroundSize: "cover",
                  }}
                >
                  <img
                    src={box.img}
                    alt={box.line1}
                    className="mb-12 xl:mb-8"
                    style={{
                      animation:
                        idx === 1
                          ? "pulseEffect 1s ease-in-out infinite"
                          : "floatEffect 1s ease-in-out infinite",
                    }}
                  />

                  <style>
                    {`
  @keyframes floatEffect {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(10px); }
  }

  @keyframes pulseEffect {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.1); }
  }
`}
                  </style>

                  <span
                    className="font-semibold w-full text-left"
                    style={{ fontSize: "37px", color: "white" }}
                  >
                    {box.line1}
                  </span>
                  <span
                    className={`w-full text-left ${
                      idx === 1 ? "text-3xl" : "text-4xl"
                    }`}
                    style={{
                      color: "var(--color-third)",
                      lineHeight: "40px",
                    }}
                  >
                    {box.line2}
                  </span>
                </AnimatedBox>
              ))
            : data.map((box, idx) => (
                <div
                  key={`container-${idx}`}
                  style={{ position: "relative" }}
                  className="hover-container xl:h-96 w-80"
                >
                  <AnimatedBox
                    key={`front-${idx}`}
                    className="flex flex-col items-center pt-8 pb-10 px-4 rounded-3xl h-full w-full max-w-sm transition-opacity"
                    style={{
                      backgroundImage: "url('/box.png')",
                      backgroundSize: "cover",
                    }}
                  >
                    <img
                      src={box.img}
                      alt={box.line1}
                      className="mb-12 xl:mb-8"
                      style={{
                        animation:
                          idx === 1
                            ? "pulseEffect 1s ease-in-out infinite"
                            : "floatEffect 1s ease-in-out infinite",
                      }}
                    />

                    <style>
                      {`
      @keyframes floatEffect {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(10px); }
      }

      @keyframes pulseEffect {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `}
                    </style>
                    <span
                      className="font-semibold w-full text-left"
                      style={{ fontSize: "37px", color: "white" }}
                    >
                      {box.line1}
                    </span>
                    <span
                      className={`w-full text-left ${
                        idx === 1 ? "text-3xl" : "text-4xl"
                      }`}
                      style={{
                        color: "var(--color-third)",
                        lineHeight: "40px",
                      }}
                    >
                      {box.line2}
                    </span>
                  </AnimatedBox>
                  <div
                    key={`back-${idx}`}
                    className="flex flex-col items-center pt-8 pb-10 px-4 rounded-3xl h-full w-full max-w-sm transition-opacity"
                    style={{
                      backgroundImage: "url('/box.png')",
                      backgroundSize: "cover",
                      position: "absolute",
                      top: "0",
                    }}
                  >
                    <img
                      src={box.img}
                      alt={box.line1}
                      className="mb-12 xl:mb-8"
                      style={{
                        animation:
                          idx === 1
                            ? "pulseEffect 1s ease-in-out infinite"
                            : "floatEffect 1s ease-in-out infinite",
                      }}
                    />

                    <style>
                      {`
      @keyframes floatEffect {
        0%, 100% { transform: translateY(0); }
        50% { transform: translateY(10px); }
      }

      @keyframes pulseEffect {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.1); }
      }
    `}
                    </style>

                    <span
                      className="font-semibold w-full text-left"
                      style={{ fontSize: "24px", color: "white" }}
                    >
                      {box.line1}
                    </span>
                    <span
                      className="w-full text-left text-2xl"
                      style={{
                        color: "var(--color-third)",
                        lineHeight: "40px",
                      }}
                    >
                      {box.line2}
                    </span>
                    <span className="w-full text-left text-white">
                      {box.line3}
                    </span>
                  </div>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
}

export default RevolutionSection;
